module.exports = __webpack_public_path__ + "static/media/frontphone-medium-lg.c8c235d7.png";